<template>
  <div class="ui form" id="form">
    <div class="three fields">
      <div class="field">
        <label>评论转发标签</label>
        <textarea v-model="purification.tags"></textarea>
      </div>
      <div class="field">
        <label>评论转发文案</label>
        <textarea v-model="purification.texts"></textarea>
      </div>
      <div class="field">
        <label>原创内容</label>
        <textarea v-model="purification.subjects"></textarea>
      </div>
    </div>

    <div class="three fields">
      <div class="field">
        <label>评论转发白名单</label>
        <textarea v-model="purification.whitelist"></textarea>
      </div>
      <div class="field">
        <label>评论转发黑名单</label>
        <textarea v-model="purification.blacklist"></textarea>
      </div>
      <div class="field">
        <label>微博投票ID</label>
        <textarea v-model="purification.polls"></textarea>
      </div>
    </div>

    <h4 class="ui dividing header">图片设置</h4>
    <div class="two fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enablePicture">
          <label>带图</label>
        </div>
      </div>
    </div>
    <div class="two fields">
      <div class="field">
        <label>图片ID</label>
        <textarea v-model="purification.pictures"></textarea>
      </div>
    </div>

    <h4 class="ui dividing header">广场净化</h4>
    <div class="two fields">
      <div class="field">
        <label>净化条目</label>
        <textarea rows="3" v-model="purification.items"></textarea>
      </div>
      <div class="field">
        <label>工作次数</label>
        <input max="60" min="0" type="number" v-model="purification.workJhCount">
      </div>
    </div>

    <div class="three fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableJhForward">
          <label>转发</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableJhComment">
          <label>评论</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableJhLike">
          <label>点赞</label>
        </div>
      </div>
    </div>

    <h4 class="ui dividing header">杨超越微博</h4>
    <div class="three fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableForward">
          <label>转发</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableComment">
          <label>评论</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableLike">
          <label>点赞</label>
        </div>
      </div>
    </div>

    <div class="field">
      <label>工作次数</label>
      <input max="60" min="0" type="number" v-model="purification.workCount">
    </div>

    <h4 class="ui dividing header">杨超越超话</h4>
    <div class="three fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableChForward">
          <label>转发</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableChComment">
          <label>评论</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableChLike">
          <label>点赞</label>
        </div>
      </div>
    </div>

    <div class="three fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableFollow">
          <label>关注</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableCheckin">
          <label>签到</label>
        </div>
      </div>
    </div>

    <div class="field">
      <label>工作次数</label>
      <input max="60" min="0" type="number" v-model="purification.workChCount">
    </div>

    <h4 class="ui dividing header">超话打榜</h4>
    <div class="three fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enablePick">
          <label>送积分</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.pickAll">
          <label>全部积分</label>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.pickForward">
          <label>转发</label>
        </div>
      </div>
    </div>

    <h4 class="ui dividing header">时间设置</h4>
    <div class="three fields">
      <div class="field">
        <label>转发后等待秒数</label>
        <input max="600" min="1" type="number" v-model="purification.forwardSleep">
      </div>
      <div class="field">
        <label>评论后等待秒数</label>
        <input max="600" min="1" type="number" v-model="purification.commentSleep">
      </div>
      <div class="field">
        <label>点赞后等待秒数</label>
        <input max="600" min="1" type="number" v-model="purification.likeSleep">
      </div>
    </div>

    <h4 class="ui dividing header">寻艺设置</h4>
    <div class="two fields">
      <div class="field">
        <div class="ui toggle checkbox">
          <input class="hidden" tabindex="0" type="checkbox" v-model="purification.enableXyCheckin">
          <label>签到</label>
        </div>
      </div>
    </div>

    <div @click="update" class="ui submit button">更新</div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'WeiboConfig',
    data () {
      return {
        purification: {
          enableForward: false,
          enableComment: false,
          enableLike: false,
          workCount: 10,
          enableJhForward: false,
          enableJhComment: false,
          enableJhLike: false,
          workJhCount: 5,
          enableChForward: false,
          enableChComment: false,
          enableChLike: false,
          workChCount: 10,
          enableFollow: false,
          enableCheckin: false,
          enablePick: false,
          pickAll: false,
          pickForward: false,
          enablePicture: false,
          enableXyCheckin: false,
          forwardSleep: 15,
          commentSleep: 10,
          likeSleep: 5,
          whitelist: '',
          blacklist: '',
          tags: '',
          texts: '',
          subjects: '',
          items: '',
          polls: '',
          pictures: '',
        }
      }
    },
    mounted () {
      $('.ui.checkbox').checkbox()
      this.load()
    },
    methods: {
      load: function () {
        axios.get('/weibo/config/purification').then((response) => {
          this.purification.enableForward = response.data.enableForward
          this.purification.enableComment = response.data.enableComment
          this.purification.enableLike = response.data.enableLike
          this.purification.workCount = response.data.workCount
          this.purification.enableJhForward = response.data.enableJhForward
          this.purification.enableJhComment = response.data.enableJhComment
          this.purification.enableJhLike = response.data.enableJhLike
          this.purification.workJhCount = response.data.workJhCount
          this.purification.enableChForward = response.data.enableChForward
          this.purification.enableChComment = response.data.enableChComment
          this.purification.enableChLike = response.data.enableChLike
          this.purification.workChCount = response.data.workChCount
          this.purification.enableFollow = response.data.enableFollow
          this.purification.enableCheckin = response.data.enableCheckin
          this.purification.enablePick = response.data.enablePick
          this.purification.pickAll = response.data.pickAll
          this.purification.pickForward = response.data.pickForward
          this.purification.enablePicture = response.data.enablePicture
          this.purification.enableXyCheckin = response.data.enableXyCheckin
          this.purification.forwardSleep = response.data.forwardSleep
          this.purification.commentSleep = response.data.commentSleep
          this.purification.likeSleep = response.data.likeSleep
          this.purification.whitelist = response.data.whitelist.join('\n')
          this.purification.blacklist = response.data.blacklist.join('\n')
          this.purification.tags = response.data.tags.join('\n')
          this.purification.texts = response.data.texts.join('\n')
          this.purification.subjects = response.data.subjects.join('\n')
          this.purification.items = response.data.items.join('\n')
          this.purification.polls = response.data.polls.join('\n')
          this.purification.pictures = response.data.pictures.join('\n')
        }, (error) => {
          console.log(error)
        })
      },
      update: function () {
        let data = {
          enableForward: this.purification.enableForward,
          enableComment: this.purification.enableComment,
          enableLike: this.purification.enableLike,
          workCount: this.purification.workCount,
          enableJhForward: this.purification.enableJhForward,
          enableJhComment: this.purification.enableJhComment,
          enableJhLike: this.purification.enableJhLike,
          workJhCount: this.purification.workJhCount,
          enableChForward: this.purification.enableChForward,
          enableChComment: this.purification.enableChComment,
          enableChLike: this.purification.enableChLike,
          workChCount: this.purification.workChCount,
          enableFollow: this.purification.enableFollow,
          enableCheckin: this.purification.enableCheckin,
          enablePick: this.purification.enablePick,
          pickAll: this.purification.pickAll,
          pickForward: this.purification.pickForward,
          enablePicture: this.purification.enablePicture,
          enableXyCheckin: this.purification.enableXyCheckin,
          forwardSleep: this.purification.forwardSleep,
          commentSleep: this.purification.commentSleep,
          likeSleep: this.purification.likeSleep,
          whitelist: this.handle(this.purification.whitelist),
          blacklist: this.handle(this.purification.blacklist),
          tags: this.handle(this.purification.tags),
          texts: this.handle(this.purification.texts),
          subjects: this.handle(this.purification.subjects),
          items: this.handle(this.purification.items),
          polls: this.handle(this.purification.polls),
          pictures: this.handle(this.purification.pictures),
        }
        axios.post('/weibo/config/purification', data).then((response) => {
        }, (error) => {
          console.log(error)
        })
      },
      handle (list) {
        return list.split('\n').filter(e => e.trim().length > 0)
      }
    }
  }
</script>

<style scoped>
  #form {
    margin-left: 12px;
    margin-right: 12px;
    text-align: left;
  }

  textarea {
    white-space: pre;
    overflow-wrap: normal;
    overflow-x: scroll;
  }
</style>